import React from "react";
import {
    OverlayTrigger,
    Tooltip,
} from "react-bootstrap";

export default function HelpTooltip({
    id,
    children,
    placement = "top",
}) {
    if (!children) {
        return null;
    }

    return (
        <OverlayTrigger
            placement={placement}
            trigger={["hover", "focus", "click"]}
            overlay={
                <Tooltip id={`${id}-tooltip`}>
                    {children}
                </Tooltip>
            }
        >
            <button
                type="button"
                className="
                    btn
                    btn-link
                    d-inline-flex
                    align-items-center
                    justify-content-center
                    p-0
                    ms-1
                    text-muted
                    border-0
                    shadow-none
                "
                aria-label="More information"
                style={{
                    width: 28,
                    height: 28,
                    lineHeight: 1,
                    textDecoration: "none",
                }}
            >
                <span
                    className="
                        d-inline-flex
                        align-items-center
                        justify-content-center
                        rounded-circle
                        border
                    "
                    style={{
                        width: 17,
                        height: 17,
                        fontSize: 11,
                        fontWeight: 600,
                    }}
                >
                    ?
                </span>
            </button>
        </OverlayTrigger>
    );
}